import { EDITOR_BASE_URL } from 'src/app/settings';

export const goToLoginScreen = () => {
  const currentUrl = window.location.href;
  const redirectTo = encodeURIComponent(currentUrl);
  window.location.href = `${EDITOR_BASE_URL}/login?redirectTo=${redirectTo}`;
};
